import { connect } from 'react-redux';
import type { FICCGreek, GenericTable, GreeksTable } from 'state/quotes/details/details.model';
import { getFormQuoteDetails, getQuoteFeesDetailLink, getUserPreferencesGreeksPrecision } from 'state/selectors';
import {
  getGreeks,
  hasFees,
  hasGreeks,
  hasHistoricalAverageCorrelations,
  hasMetrics,
  hasPrices,
  hasProductGreeks,
} from 'state/selectors/meta/quote/utils';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { toggleQuoteInfosSection } from 'state/uiPanelState/quoteDetail/quoteDetail.action';
import { collapsedSections } from 'state/uiPanelState/quoteDetail/quoteDetail.selector';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;

  quotesFeesDetailLink?: string;
}

export interface GreeksFeesMetricsDispatchProps {
  toggleSectionVisibility: (section: string) => void;
}

export interface GreeksFeesMetricsStateProps {
  hasFees: boolean;
  hasGreeks: boolean;
  hasMetrics: boolean;
  hasHistoricalAverageCorrelations: boolean;
  hasPrices: boolean;
  hasProductGreeks: boolean;

  collapsedSections: string[];

  ficcGreeks?: Readonly<FICCGreek[]>;
  greeks?: GreeksTable;
  sensitivities?: Readonly<GenericTable[]>;

  quoteFeesDetailLink?: string;
  precisionGreeks: number;
}

export type GreeksFeesMetricsProps = OwnProps & GreeksFeesMetricsStateProps & GreeksFeesMetricsDispatchProps;

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): GreeksFeesMetricsStateProps => {
  const sections = collapsedSections(state, tabId);
  const quoteDetails = getFormQuoteDetails(state, workspaceType, tabId);
  const quoteFeesDetailLink = getQuoteFeesDetailLink(state, workspaceType, tabId);

  return {
    collapsedSections: sections,
    hasFees: hasFees(state, workspaceType, tabId),
    hasGreeks: hasGreeks(state, workspaceType, tabId),
    hasMetrics: hasMetrics(state, workspaceType, tabId),
    hasHistoricalAverageCorrelations: hasHistoricalAverageCorrelations(state, workspaceType, tabId),
    hasPrices: hasPrices(state, workspaceType, tabId),
    hasProductGreeks: hasProductGreeks(state, workspaceType, tabId),
    quoteFeesDetailLink,
    greeks: getGreeks(state, workspaceType, tabId),
    ficcGreeks: quoteDetails?.FICCGreeks,
    sensitivities: quoteDetails?.sensitivities,
    precisionGreeks: getUserPreferencesGreeksPrecision(state) ?? 4,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): GreeksFeesMetricsDispatchProps => {
  return {
    toggleSectionVisibility: section => {
      dispatch(toggleQuoteInfosSection(tabId, section));
    },
  };
};

export const connectGreeksFessMetricsTabContent = connect(mapStateToProps, mapDispatchToProps);
